// @flow

import type { RepostInfo } from '../submit/SubmitIapVote';

export type ContentIdType = number | string;

/**
 * Return an id if it is a string.
 *
 * @param contentType the id to check.
 * @returns the id if it is a string, or undefined.
 */
const contentIdTypeToString = (contentType: ?ContentIdType): ?string =>
  typeof contentType === 'string' ? contentType : undefined;

/**
 * Convert a number or string id into a string.
 * CMI-4110: Numeric ids were being passed in as strings, so do the actual conversion.
 *
 * @param contentType the number or string value.
 * @returns the number if conversion succeeds, or undefined.
 */
const contentIdTypeToNumber = (contentType: ?ContentIdType): ?number =>
  typeof contentType === 'number' ? contentType : Number(contentType) || undefined;

/**
 * Default properties all content panels will require
 */
export type ContentProps = {|
  contentId: ContentIdType,
  onError: any,
  onComplete: any,
  repostInfo?: RepostInfo,
|};

export type InternalProps = {|
  userId: string,
  csrfToken: string,
  locale: string,
|};

export type InternalContentProps = {|
  ...ContentProps,
  ...InternalProps,
|};

const DefaultProps = {
  repostInfo: undefined,
};

const defaultConnect = (state: any): InternalProps => ({
  csrfToken: state.auth.csrfToken,
  userId: state.auth.loggedInUserId,
  locale: state.i18n.locale,
});

export { DefaultProps, defaultConnect, contentIdTypeToString, contentIdTypeToNumber };
